const styles = (theme) => ({
	pageTopSpace: {
		display: "flex",
		width: "100%",
		position: "sticky",
		justifyContent: "center",
		top: 0,
		alignItems: "center",
		height: "40px",
		"@media (max-width: 681px)": {
			height: "60px",
		},
		//mb: "40px",
	},
	contentBox: {
		display: "flex",
		width: "100%",
		position: "fixed",
		justifyContent: "center",
		top: 0,
		zIndex: 1000,
		backgroundColor: theme.palette.tertiary.main,
		height: "40px",
		"@media (max-width: 681px)": {
			height: "65px",
		},
	},
	boxButton: {
		flexDirection: "row",
		display: "flex",
		width: "100%",
		pl: "50px",
		pr: "60px",
		justifyContent: "space-between",
		alignItems: "center",
	},
	returnBt: {
		color: theme.palette.white.main,
		"@media (max-width: 760px)": {
			fontSize: "11px",
			textAlign: "center",
		},
		"&.MuiButton-root": {
			borderColor: theme.palette.white.main,
		},
	},
	helperTitle: {
		color: theme.palette.white.main,
		ml: "20px",
		fontWeight: 800,
		"@media (max-width: 760px)": {
			fontSize: "14px",
			textAlign: "center",
		},
	},
});

export default styles;
